import { firebaseAuth, firebaseFunctionsUrl } from '../firebase';
import qs from 'qs';

export const getApiUrl = (url: string, params?: any) => `${firebaseFunctionsUrl}/api/${url}${params ? `?${qs.stringify(params)}` : ''}`;

export const get = async (url: string, params?: any) => {
    const token = await getAuthHeaderToken();
    let auth = {};
    if (token) {
        auth = { 'Authorization': 'Bearer ' + token };
    }

    const options = {
        method: 'GET',
        headers: {
            ...auth
        }
    };

    const response = await fetch(getApiUrl(url, params), options);
    const json = await response.json();

    console.log('GET', url, json);

    return json;
};

export const put = async (url: string, body?: Record<string, any>) => {
    const token = await getAuthHeaderToken();
    let auth = {};
    if (token) {
        auth = { 'Authorization': 'Bearer ' + token };
    }

    const options = {
        method: 'PUT',
        body: body ? JSON.stringify(body) : '',
        headers: {
            'Content-Type': 'application/json',
            ...auth
        }
    };

    const response = await fetch(getApiUrl(url), options);

    const json = await response.json();

    console.log('PUT', url, json);

    return json;
};

const getAuthHeaderToken = async () => {
    if (!firebaseAuth.currentUser) {
        return null;
    }

    return await firebaseAuth.currentUser.getIdToken(true);
};
